/* eslint-disable react/prop-types */
import {Component, Fragment} from 'react';

import styles from './portal-breadcrumbs.component.module.scss';

/**
 * A single breadcrumb segment. `href` may be omitted on the last item
 * (rendered as the current page label).
 */
export interface BreadcrumbItem {
    label: string;
    href?: string;
}

export interface PortalBreadcrumbsProps {
    items: BreadcrumbItem[];
}

/**
 * Chip-style breadcrumb trail rendered above the page title.
 *
 * Example: `Portal > Billing > History`. The last item is treated as
 * the current page and rendered as a non-clickable, accent-tinted pill.
 */
export default class PortalBreadcrumbs extends Component<PortalBreadcrumbsProps> {
    render() {
        const {items} = this.props;
        if (!items || items.length === 0) return null;

        return (
            <nav className={styles.nav} aria-label="Breadcrumb">
                <ol className={styles.crumbList}>
                    {items.map((item, idx) => {
                        const isLast = idx === items.length - 1;
                        return (
                            <Fragment key={`${item.label}-${idx}`}>
                                <li className={styles.crumb}>
                                    {isLast || !item.href ? (
                                        <span
                                            className={styles.crumbCurrent}
                                            aria-current={isLast ? 'page' : undefined}
                                        >
                                            {item.label}
                                        </span>
                                    ) : (
                                        <a className={styles.crumbLink} href={item.href}>
                                            {item.label}
                                        </a>
                                    )}
                                </li>
                                {!isLast && (
                                    <li className={styles.sep} aria-hidden="true">
                                        <svg
                                            viewBox="0 0 12 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M4.5 2.5L8 6L4.5 9.5"
                                                stroke="currentColor"
                                                strokeWidth="1.4"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </li>
                                )}
                            </Fragment>
                        );
                    })}
                </ol>
            </nav>
        );
    }
}
